<template>
  <v-row justify="center">
    <v-col cols="12" md="8" class="text-center">
      <v-dialog v-model="showForm" persistent max-width="800" scrollable>
        <v-card class="pa-10 onboarding-card">
          <v-card-text class="onboarding-content">
            <v-chip x-small label class="material-typ-badge mb-5">SCHRITT {{ currentStep }} VON 2</v-chip>
            <div class="signup-title">Für die Aktivierung Ihres Kontos fehlen uns noch einige Informationen.</div>
            <v-row class="mt-5 portal-selection-row" v-if="!preferredPortal">
              <v-col cols="12" sm="6">
                <v-sheet width="100%" color="#931880" elevation="1" class="portal-select-card">
                  <div>
                  <p class="select-card-title">Ich arbeite im<br>Bildungswesen</p>
                  <p>und möchte auf Bildungs-angebote für Lehrkräfte, pädagogische Fachkräfte und Bildungseinrichtungen zugreifen.</p>
                  </div>
                  <v-btn class="portal-select-button" elevation="0" text color="white" @click="preferredPortal = 'bildungsportal'">
                    Weiter
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="6">
                <v-sheet width="100%" color="primary" elevation="1" class="portal-select-card">
                  <div>
                  <p class="select-card-title">Ich arbeite im<br>Kommunalmanagement</p>
                  <p>und möchte auf alle Inhalte des <br>NEW-Kommunalportals zugreifen.</p>
                  </div>
                  <v-btn class="portal-select-button" elevation="0" text color="white" @click="preferredPortal = 'kommunalportal'">
                    Weiter
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>
            <v-form @submit.prevent="onFormSubmit" v-else no-gutters class="mt-5">
            <v-row>
              <v-col cols="12" v-if="preferredPortal === 'kommunalportal'">
                  <v-select
                      class="mb-4"
                      v-model="preferredRole"
                      :items="getRoles"
                      label="Rolle"
                      hide-details filled dense
                      color="primary"
                      background-color="rgb(235, 217, 227)"
                      :rules="roleRules"
                      @change="onRoleChange"
                      required />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    class="mb-4"
                    v-model="preferredCommune"
                    label="Kommune"
                    hide-details filled dense
                    required
                    :rules="communeRules"
                    color="primary"
                    background-color="rgb(235, 217, 227)"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="telefon"
                    label="Ihre Telefonnummer (optional)"
                    hide-details filled dense
                    color="primary"
                    background-color="rgb(235, 217, 227)"
                />
                <v-col col="12" class="d-flex justify-center">
                  <v-btn class="mt-2 px-15" color="primary" :disabled="disableSubmitButton" type="submit">Absenden</v-btn>
                </v-col>
              </v-col>
            </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card class="pa-9" v-if="!showForm">
        <h2 class="text--secondary font-weight-light custom-header-text">
          <v-icon style="font-size: 1em; vertical-align: top">
            mdi-account-clock
          </v-icon>
          Konto-Freischaltung läuft...
        </h2>

        <v-divider class="mb-8 mt-3" />
        <template v-if="!showForm">
          <h4 class="text-h6 mb-2">
            Hallo <b>{{ getUsername() }}</b>!
          </h4>
          <p class="body-1 mb-6">
            Ihr Kommunalportal-Konto wird derzeit von uns zur Freischaltung geprüft -
            Sie erhalten eine E-Mail an <b>{{ getEmail() }}</b>
            sobald ihr Profil von uns bestätigt wurde.
          </p>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { metricEventTypes, metricParents } from "@/lib";

export default {
  name: "ApprovalPending",
  data: () => ({
    preferredPortal: undefined,
    preferredRole: null,
    preferredCommune: null,
    roleRules: [
      v => !!v || 'Bitte wählen Sie eine Rolle aus',
    ],
    communeRules: [
      v => !!v || 'Bitte geben Sie eine Kommune an',
    ],
    telefon: undefined,
  }),
  mounted() {
    this.loadRoles();
    this.postHeartbeat({
      name: 'Warten auf Freigabe',
      parent: metricParents.NONE,
      type: metricEventTypes.PAGE_VISIT,
    })
  },
  computed: {
    ...mapGetters('user', ['showRegisterForm']),
    ...mapGetters('userDetails', ['getRoles']),
    disableSubmitButton() {
      return (this.preferredPortal === 'kommunalportal' && !this.preferredRole) || !this.preferredCommune;
    },
    currentStep() {
      return this.preferredPortal ? 2 : 1;
    },
    showForm() {
      return this.showRegisterForm;
    },
  },
  methods: {
    ...mapActions("metrics", ["postHeartbeat"]),
    ...mapActions('userDetails', ['loadRoles', 'updatePreferredData']),
    onRoleChange() {
      if(this.preferredRole === 'Gremienmitglieder') {
        this.preferredCommune = 'Gremienmitglieder';
      } else {
        this.preferredCommune = null;
      }
    },
    async onFormSubmit() {
      const data = {
        preferredData: {
          preferredFaculty: this.preferredPortal === 'kommunalportal' ? this.preferredRole : 'Bildungsportal',
          preferredCommune: this.preferredCommune,
        },
        telefon: this.telefon,
      };
      await this.updatePreferredData(data);

      if(!this.showRegisterForm) {
        this.preferredRole = null;
        this.preferredCommune = null;
      }
    },
    getUsername() {
      return String(this.$store.getters["user/username"]).trim();
    },
    getEmail() {
      return this.$store.getters["user/userEmail"];
    },
  },
};
</script>

<style scoped>
.onboarding-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  overflow: hidden;
}

.onboarding-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.signup-title {
  font-size: 30px;
  font-weight: bold;
  line-height: 35px;
}

.portal-select-card {
  color: white;
  min-height: 228px;
  height: 100%;
  padding: 20px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.portal-select-card > div {
  width: 100%;
}

.portal-select-button {
  margin-top: 16px;
}

.select-card-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
}

@media only screen and (max-width: 599px) {
  .onboarding-card {
    max-height: calc(100vh - 32px);
    padding: 20px !important;
  }

  .onboarding-content {
    padding: 0 !important;
  }

  .signup-title {
    font-size: 25px;
    line-height: 30px;
  }

  .portal-selection-row {
    margin-top: 20px !important;
  }

  .portal-select-card {
    min-height: 0;
    height: auto !important;
  }

  .select-card-title {
    font-size: 19px;
    line-height: 24px;
  }

  .portal-select-card p {
    line-height: 21px;
  }
}
</style>
